import { Sparkles, Coffee } from 'lucide-react';

export const ProductHighlights = ({ product }) => (
  <section className="py-20">
    <div className="container mx-auto grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-5 relative">
        <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-card">
          <img src={product.secondaryImage || product.image} alt={product.name} className="h-full w-full object-cover" />
        </div>
        <div className="absolute -bottom-5 -right-5 sm:right-5 bg-card border border-border rounded-2xl shadow-pop p-5 max-w-[240px]">
          <Sparkles className="h-4 w-4 text-accent" />
          <div className="font-display text-base text-primary font-semibold mt-2 leading-snug">
            Photographs as well as it bakes.
          </div>
          <div className="text-xs text-muted-foreground mt-1">Press-ready imagery available with every wholesale account.</div>
        </div>
      </div>
      <div className="lg:col-span-7">
        <div className="font-script text-2xl text-leaf">why it works</div>
        <h2 className="font-display text-3xl sm:text-4xl text-primary font-medium mt-1 leading-tight">
          Four reasons this line sells through.
        </h2>
        <div className="grid sm:grid-cols-2 gap-4 mt-7">
          {product.highlights.map((h, i) => (
            <div key={h} className="flex items-start gap-3 p-5 rounded-2xl bg-card border border-border/70">
              <div className="h-8 w-8 shrink-0 rounded-full gradient-leaf text-primary-foreground grid place-items-center font-display text-sm font-semibold">
                {i + 1}
              </div>
              <div className="text-sm text-primary/90 leading-relaxed pt-0.5">{h}</div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground flex items-center gap-2"><Coffee className="h-3.5 w-3.5 text-leaf" /> Suggested pairings</div>
          <div className="flex flex-wrap gap-2 mt-3">
            {product.pairings.map((p) => (
              <span key={p} className="px-3.5 py-1.5 rounded-full bg-secondary text-sm text-primary font-medium">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ProductHighlights;
